import {
  DataObjectId,
  getColumnColorNumber,
  Hub,
  SandboxTree
} from 'yougile-model'
import {getColumnByTaskId} from '@extensions/column'

export const calculateHue = (
  hueIndex: Record<DataObjectId, number>,
  box: SandboxTree,
  hub: Hub
): number => {
  if (hueIndex[hub.location] !== undefined) {
    return hueIndex[hub.location]
  }

  const column = getColumnByTaskId(box, hub)
  if (!column) {
    return 1
  }

  const hueCached = hueIndex[column.id]
  if (hueCached !== undefined) {
    return hueCached
  }

  const hue = getColumnColorNumber(column).hue
  hueIndex[column.id] = hue
  hueIndex[hub.location] = hue
  return hue
}
